import React from 'react';
import { Checkbox } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import ErrorMessage from "../../Shared/Error/ErrorMessage";
import NumericInput from "./NumericInput";
import { useTranslation } from "react-i18next";

const UnitButton = (props) => {
	const { unit } = props;

	let symbol = unit;

	if (unit === "percentage") {
		symbol = <i className="far fa-percentage" />
	} else if (unit === "euro") {
		symbol = <i className="far fa-euro-sign"></i>
	} else if (unit === "pound") {
		symbol = <i className="far fa-pound-sign"></i>
	} else if (unit === "dollar") {
		symbol = <i className="far fa-dollar-sign"></i>
	}

	return (
		<Button>
			{symbol}
		</Button>
	)
}

export const NumberDefaultValueField = (props) => {

	const { t } = useTranslation([
		"attribute/number_field"
	], {
		useSuspense: false
	});

	const { defaultValue, errors, numberType, decimalPlace, unit, unitSide, useThousandSeparator, onChange } = props;

	let format = {};

	if (useThousandSeparator) {
		if (numberType === "integer") {
			format = "n0";
		} else {
			format = {
				style: "decimal",
				minimumFractionDigits: parseInt(decimalPlace),
				useGrouping: true
			}
		}
	} else {
		if (numberType === "integer") {
			format = "#";
		} else {
			format = {
				style: "decimal",
				minimumFractionDigits: parseInt(decimalPlace)
			}
		}
	}


	if (unitSide === "Left") {
		return (
			<>
				<div className="form-label d-inline-block">
					{t("default_value")}
				</div>
				<ErrorMessage
					valid={errors.isDefaultValueValid}
					error={errors.defaultValueError}
				/>
				<div className="d-flex">
					{
						unit !== "none" && unit && unit.trim() !== "" &&
						<UnitButton unit={unit} />
					}
					<NumericInput
						className="form-control"
						name="defaultValue"
						format={format}
						value={defaultValue}
						onChange={onChange}
					/>
				</div>
			</>
		)
	}

	return (
		<>
			<div className="form-label d-inline-block">
				{t("default_value")}
			</div>
			<ErrorMessage
				valid={errors.isDefaultValueValid}
				error={errors.defaultValueError}
			/>
			<div className="d-flex">
				<NumericInput
					className="form-control"
					name="defaultValue"
					format={format}
					value={defaultValue}
					onChange={onChange}
				/>
				{
					unit !== "none" && unit && unit.trim() !== "" &&
					<UnitButton unit={unit} />
				}
			</div>
		</>
	);
}

const NumberField = (props) => {

	const { t } = useTranslation([
		"attribute/number_field"
	], {
		useSuspense: false
	});

	const decimalOptions = [
		"0",
		"1",
		"2",
		"3",
		"4",
		"5"
	];

	const sides = ["Left", "Right"];

	const {
		decimalPlace,
		useThousandSeparator,
		unit,
		unitSide,
		onChange,
		numberType
	} = props;

	function handleUnit(unit) {
		onChange({
			target: {
				name: "unit",
				value: unit
			}
		})
	}

	function handleCheckbox(e) {
		onChange({
			target: {
				name: "useThousandSeparator",
				value: e.value
			}
		})
	}

	function getCustomValue() {
		if (
			unit === "none" ||
			unit === "percentage" ||
			unit === "dollar" ||
			unit === "euro" ||
			unit === "pound"
		) {
			return "";
		}

		return unit;
	}

	return (
		<>
			<div className="form-label d-block">
				{t("format")}
			</div>
			{/* <ButtonGroup> */}
			<div className='d-flex'>
				<button
					type="button"
					className={`me-1 btn ${unit === "none" ? 'btn-primary' : 'btn-secondary'} `}
					togglable={true}
					name="none"
					onClick={() => handleUnit("none")}>
					{t("none")}
				</button>
				<button
					type="button"
					className={`me-1 btn ${unit === "percentage" ? 'btn-primary' : 'btn-secondary'} `}
					togglable={true}
					name="percentage"
					onClick={() => handleUnit("percentage")}>
					<i className="far fa-percentage"></i>
				</button>
				<button
					type="button"
					className={`me-1 btn ${unit === "dollar" ? 'btn-primary' : 'btn-secondary'} `}
					togglable={true}
					name="dollar"
					onClick={() => handleUnit("dollar")}>
					<i className="far fa-dollar-sign"></i>
				</button>
				<button
					type="button"
					className={`me-1 btn ${unit === "euro" ? 'btn-primary' : 'btn-secondary'} `}
					togglable={true}
					name="euro"
					onClick={() => handleUnit("euro")}>
					<i className="fal fa-euro-sign"></i>
				</button>
				<button
					type="button"
					className={`me-1 btn ${unit === "pound" ? 'btn-primary' : 'btn-secondary'} `}
					togglable={true}
					name="pound"
					onClick={() => handleUnit("pound")}>
					<i className="far fa-pound-sign"></i>
				</button>
				<input
					placeholder={t("type_our_own_placeholder")}
					name="unit"
					className="form-control"
					onChange={onChange}
					maxLength={10}
					value={getCustomValue()} />
				{/* </ButtonGroup> */}
			</div>
			{
				unit !== "none" &&
				<>
					<div className="form-label">
						{t("unit_side")}
					</div>
					<DropDownList
						className="w-100"
						name="unitSide"
						data={sides}
						value={unitSide}
						onChange={onChange} />
				</>
			}

			{
				numberType === "decimal" &&
				<>
					<div className="form-label" htmlFor={t("decimal_places")}>
						{t("decimal_places")}
					</div>
					<DropDownList
						className="form-control-custom"
						data={decimalOptions}
						name="decimalPlace"
						value={decimalPlace}
						onChange={onChange} />
				</>
			}

			<div className="mt-1">
				<Checkbox
					id="thousand_separator"
					name="useThousandSeparator"
					checked={useThousandSeparator}
					onChange={handleCheckbox}
					label={t("use_thousands_separator")}
				/>
			</div>
		</>
	);
};
export default NumberField;
